export const EVENTS = {
    SAVE: 'SAVE'
}